function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var MapService = /*#__PURE__*/function () {
  function MapService() {
    _classCallCheck(this, MapService);
  }
  _createClass(MapService, [{
    key: "construct",
    value: function construct($canvas, settings) {}
  }, {
    key: "setType",
    value: function setType(type) {}
  }, {
    key: "getCenter",
    value: function getCenter() {}
  }, {
    key: "setCenter",
    value: function setCenter(center) {}
  }, {
    key: "setZoom",
    value: function setZoom(zoom) {}
  }, {
    key: "getZoom",
    value: function getZoom() {}
  }, {
    key: "addPins",
    value: function addPins(pins) {}
  }, {
    key: "geocode",
    value: function geocode(query) {
      var country = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    }
  }, {
    key: "getPinsWithinRange",
    value: function getPinsWithinRange(lat, lng, rangeInMeters) {}
  }, {
    key: "getPinClosestTo",
    value: function getPinClosestTo(lat, lng) {}
  }, {
    key: "getPinDistance",
    value: function getPinDistance(lat, lng, pin) {}
  }, {
    key: "highlightPin",
    value: function highlightPin(pin) {}
  }, {
    key: "fitPins",
    value: function fitPins(pins) {}
  }, {
    key: "updatePinVisibility",
    value: function updatePinVisibility(pin) {}
  }, {
    key: "locate",
    value: function locate() {}
  }, {
    key: "redraw",
    value: function redraw() {}
  }]);
  return MapService;
}();
;
module.exports = MapService;